import * as React from 'react';

import { EFacilityType, JsonQuery, NonEmptyArray } from '../../../../../JsonQuery';
import { BathType } from '../../../components/advancedFilters/BathType';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const BathTypeContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const bathTypes = new JsonQuery(jsonQuery).getBathTypes();

  const handleBathTypesChange = React.useCallback(
    (bathTypes: NonEmptyArray<EFacilityType> | null) => {
      onChange({ action: 'setBathTypes', arguments: [bathTypes] });
    },
    [onChange],
  );

  return <BathType value={bathTypes} onChange={handleBathTypesChange} />;
};
